import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SecureStorage from "react-secure-storage";
//CSS
import "./PatientList.css";
//Assets
import PatientListOpen from "../../assets/images/patientListOpen.svg";
import PatientListClose from "../../assets/images/patientListClose.svg";
import Arrow from "../../assets/images/Arrow.svg";
import Plus from "../../assets/images/Plus.svg";
import Search from "../../assets/images/Search.svg";
import Calendar from "../../assets/images/CalendarMonth.svg";

import { PatientApi } from "../../api";
import AddPatient from "../AddPatient/AddPatient";

const PatientList = ({
  onPatientSelect,
  onRefreshReady,
  onPatientCreated,
  step,
  setStep,
  goToMain,
}) => {
  const navigate = useNavigate();
  const doctorId = SecureStorage.getItem("doctorId");
  const [width, setWidth] = useState(380);
  const [hidden, setHidden] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [patientList, setPatientList] = useState([]);
  useEffect(() => {
    getPatientList();
  }, [doctorId]);

  useEffect(() => {
    if (onRefreshReady) {
      onRefreshReady(getPatientList);
    }
  }, [onRefreshReady]);

  useEffect(() => {
    if (!search || !doctorId) {
      if (!search && doctorId) {
        getPatientList();
      }
      return;
    }
    const searchPatient = async () => {
      const response = await PatientApi.searchPatient({
        doctorId,
        code: search,
      });
      if (response === null || !Array.isArray(response)) {
        setPatientList([]);
        return;
      }
      setPatientList(response);
    };
    searchPatient();
  }, [search, doctorId]);

  const handleWidth = () => {
    setWidth(58);
    setHidden(true);
    if (width === 58) {
      setWidth(380);
      setTimeout(() => {
        setHidden(false);
      }, 150);
    }
  };

  const getPatientList = async () => {
    if (!doctorId) {
      setPatientList([]);
      return;
    }
    const response = await PatientApi.getPatientList(doctorId);
    if (response === null || !Array.isArray(response)) {
      setPatientList([]);
      return;
    }
    setPatientList(response);
  };

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  //Modal
  const [addPatientState, setAddPatientState] = useState(false);
  const handleOpenAddPatient = () => {
    setAddPatientState(true);
  };
  const handleCloseAddPatient = () => {
    setAddPatientState(false);
  };

  const selectPatient = async (patientId) => {
    try {
      const response = await PatientApi.getPatientInfo({ patientId });
      if (response) {
        navigate(`/result/${patientId}`);
      }
    } catch (error) {
      console.error("selectPatient error", error);
    }
  };
  return (
    <div
      className="patient-list-container"
      style={{
        width: `${width}px`,
      }}
    >
      <div className="patient-list-header">
        <div className="patient-list-header-title-wrapper">
          <PatientListOpen
            className={`patient-list-menu-icon ${hidden ? "hidden" : ""}`}
            alt="patientListOpen"
          />
          <PatientListClose
            className={`patient-list-menu-icon ${!hidden ? "hidden" : ""}`}
            alt="patientListClose"
            onClick={handleWidth}
          />
          <div className={`patient-list-title ${hidden ? "hidden" : ""}`}>
            환자 리스트
          </div>
        </div>
        <div
          className={`patient-list-header-hidden-button ${
            hidden ? "hidden" : ""
          }`}
          onClick={handleWidth}
        >
          <Arrow alt="arrow" />
        </div>
      </div>
      <div
        className={`patient-list-add-search-patient-wrapper ${
          hidden ? "hidden" : ""
        }`}
      >
        <button
          className={`patient-list-add-patient ${hidden ? "hidden" : ""}`}
          type="button"
          onClick={handleOpenAddPatient}
        >
          <Plus alt="Plus" />
          <span>환자 생성 하기</span>
        </button>
        <div
          className={`patient-list-search-wrapper ${hidden ? "hidden" : ""}`}
        >
          <input
            type="text"
            className="patient-list-search-input"
            placeholder="환자 이름 검색"
            onChange={(e) => setSearch(e.target.value)}
          />
          <Search className="patient-list-search-icon" alt="Search" />
        </div>
      </div>

      <div className={`patient-list-patient-list ${hidden ? "hidden" : ""}`}>
        {Array.isArray(patientList) &&
          patientList.map((item) => {
            if (!item || !item.patientId) return null;
            return (
              <div
                key={item.patientId}
                className={`patient-list-patient-item ${
                  selectedId === item.patientId
                    ? "patient-list-patient-item-selected"
                    : ""
                }`}
                onClick={() => {
                  selectPatient(item.patientId);
                  setSelectedId(item.patientId);
                }}
              >
                <div
                  className={`patient-list-patient-item-name ${
                    selectedId === item.patientId
                      ? "patient-list-patient-item-name-selected"
                      : ""
                  }`}
                >
                  {item.patientCode}
                </div>
                <div className="patient-list-patient-item-bottom-wrapper">
                  <div className="patient-list-patient-item-insert-date">
                    <Calendar alt="Calendar" />
                    {formatDate(item.insertDate)}
                  </div>
                  <div className="patient-list-patient-item-position">
                    {["LEFT", "RIGHT"].map((position) => {
                      const diagnosis = item.diagnosisList?.find(
                        (d) => d.position === position
                      );
                      const status = diagnosis?.finalDiagnosisStatus;
                      const statusClass = status
                        ? `patient-list-position-${status.toLowerCase()}`
                        : "patient-list-position-gray";

                      return (
                        <div
                          key={position}
                          className={`patient-list-position-item ${statusClass}`}
                        >
                          {position}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        {Array.isArray(patientList) &&
          patientList.map((item) => {
            if (!item || !item.patientId) return null;
            return (
              <div
                key={item.patientId}
                className={`patient-list-patient-item ${
                  selectedId === item.patientId
                    ? "patient-list-patient-item-selected"
                    : ""
                }`}
                onClick={() => {
                  setSelectedId(item.patientId);
                  if (onPatientSelect) {
                    onPatientSelect(item.patientId);
                  }
                }}
              >
                <div
                  className={`patient-list-patient-item-name ${
                    selectedId === item.patientId
                      ? "patient-list-patient-item-name-selected"
                      : ""
                  }`}
                >
                  {item.patientCode}
                </div>
                <div className="patient-list-patient-item-bottom-wrapper">
                  <div className="patient-list-patient-item-insert-date">
                    <Calendar alt="Calendar" />
                    {formatDate(item.insertDate)}
                  </div>
                  <div className="patient-list-patient-item-position">
                    {["LEFT", "RIGHT"].map((position) => {
                      const diagnosis = item.diagnosisList?.find(
                        (d) => d.position === position
                      );
                      const status = diagnosis?.finalDiagnosisStatus;
                      const statusClass = status
                        ? `patient-list-position-${status.toLowerCase()}`
                        : "patient-list-position-gray";

                      return (
                        <div
                          key={position}
                          className={`patient-list-position-item ${statusClass}`}
                        >
                          {position}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <AddPatient
        state={addPatientState}
        setState={setAddPatientState}
        handleOpen={handleOpenAddPatient}
        handleClose={handleCloseAddPatient}
        doctorId={doctorId}
        onPatientCreated={onPatientCreated}
        step={step}
        setStep={setStep}
        goToMain={goToMain}
      />
    </div>
  );
};

export default PatientList;
